import type { Event } from '@cocoonspace/sdk-js/types/event'
import { useCopyClipboard } from '@cocoonspace/shared/hooks/use-copy-clipboard.hook'
import { Calendar, Link } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import { Button } from '~/components/ui/button'
import { AddToCalendar } from '../atoms/add-to-calendar'

const CopyEventLink = ({ event }: { event: Event }) => {
	const { t } = useTranslation()
	const { copyToClipboard, isCopied } = useCopyClipboard()

	const link = `${document.location.host}/event/${event.id}`

	return (
		<div className='flex items-center gap-x-2'>
			<div className='grid overflow-x-auto'>
				<p
					title={link}
					className='w-full truncate rounded-full bg-slate-200 px-4 py-1 text-xs'
				>
					{link}
				</p>
			</div>

			<Button
				size='sm'
				variant='link'
				className='whitespace-nowrap border-none'
				onClick={() => copyToClipboard(link)}
			>
				<Link
					size={16}
					className='mr-2 text-primary'
				/>

				{isCopied
					? t('actions:copyLink.successMessage')
					: t('actions:copyLink.btnLabel')}
			</Button>
		</div>
	)
}

export const EventShareWidgetFooter = ({ event }: { event: Event }) => {
	const { t } = useTranslation()

	return (
		<div className='flex flex-col items-stretch gap-x-2 gap-y-4 sm:flex-row sm:gap-y-0'>
			<AddToCalendar event={event}>
				<Button
					className='whitespace-nowrap sm:mr-auto'
					variant='outline'
					size='sm'
				>
					<Calendar
						size={16}
						className='mr-2'
					/>

					{t('cwEvents:addToCalendar')}
				</Button>
			</AddToCalendar>

			<CopyEventLink event={event} />
		</div>
	)
}
